import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { filterBonding } from "api/prequalify";

import { StyledQuestion, StyledBox, PlaceholderText } from "../styles";

import { ResultPanel } from "../bankPicklist/resultPanel";
import { FunctionalButton } from "components/functionalButton";
import { AddFinancialPopup } from "../../../../components/addFinancialPopup";
import { EmptyPanel } from "../bankPicklist/emptyPanel";
import SelectedProjects from "../bankPicklist/components/selectedProjects";
import { useSelector } from "react-redux";
import { getECQSWizardContextSelector } from "data/selectors/ecqs";

export const BondingPicklist = ({
  setActiveStep,
  handleNext,
  prequalifyData,
  setPrequalifyData,
  setIsLastPanel,
  setPreviousStepPanel,
  setPanel,
  popupTitle,
  setRerender,
  institutionId,
}) => {
  setIsLastPanel(true);
  setPreviousStepPanel(1);

  const wizardContext = useSelector(getECQSWizardContextSelector);
  const isEsub = wizardContext === "e-sub";

  const isMobile = useMediaQuery({ maxWidth: 960 });

  const [object, setObject] = useState(
    prequalifyData?.bonding?.company_name ? prequalifyData?.bonding : ""
  );

  const [list, setList] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [pickedArray, setPickedArray] = useState([]);

  useEffect(() => {
    setPrequalifyData("bonding", object);
  }, [object]);

  const handleFilter = async () => {
    await filterBonding("", { institution_id: institutionId })
      .then((data) => {
        setList(data);
        setFilteredData(data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handleFilter();
  }, []);

  const addFinancial = (data) => {
    setObject(data);
  };

  return (
    <>
      <StyledQuestion marginBottom="32px">
        {isEsub ? "Which Bonding Company Does the Contract Currently Work With?" : "Which Bonding Company do you currently work with?"}
      </StyledQuestion>
      {!object && (
        <StyledBox boxWidth="844px">
          <PlaceholderText>Selected Bonding will appear here</PlaceholderText>
        </StyledBox>
      )}
      {object && (
        <SelectedProjects
          object={object}
          setObject={setObject}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
          pickedArray={pickedArray}
          setPickedArray={setPickedArray}
          setRerender={setRerender}
        />
      )}
      {list?.length < 1 && (
        <EmptyPanel
          object={object}
          setObject={setObject}
          setOpenPopup={setOpenPopup}
        />
      )}
      {list?.length > 0 && (
        <ResultPanel
          object={object}
          setObject={setObject}
          setOpenPopup={setOpenPopup}
          openPopup={openPopup}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
          filterApi={filterBonding}
          pickedArray={pickedArray}
          disabled={object}
        />
      )}
      <FunctionalButton
        buttonTitle="Next"
        handleButton={() => handleNext()}
        width="200px"
        marginRight="auto"
        marginLeft="auto"
        marginTop="16px"
        disabled={!object}
      />
      <AddFinancialPopup
        setOpenPopup={setOpenPopup}
        openPopup={openPopup}
        handleButtonFunc={addFinancial}
        popupTitle={popupTitle}
        data={{ type: "bonding" }}
      />
    </>
  );
};

export default BondingPicklist;
